export default __webpack_public_path__ + "static/media/ILUSTRACIONES_12.faa27f7a.png";